<div class="d-flex">
  <app-tabs-form [activeForm]="activeForm" [account_type]="account_type" [draft]="draft" [role]="role"
    [updatesTabs]="updatesTabs" [document_buttons_chico]="document_buttons_chico"></app-tabs-form>

  <div class="card w-100 form-right">
    <div class="back">
      <h2> {{('forms.names.addfromcampaign' | translate)}}</h2>
      <i class="icon-cross2" (click)="emitBackButtonClick()"></i>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form">
          <form [formGroup]="form">
            <div [hidden]="activeForm !== 'campaign'">
              <app-campaign-form [campaignData]="campaignData" [ladata]="ladata"></app-campaign-form>
            </div>
          </form>
        </div>
      </div>
      <div class="div-form">
        <div class="btn-send d-flex align-items-center justify-content-end w-100 ml-4">
           <button type="submit" class="btn btn-primary btn-primary-form" (click)="onSubmit()">
             {{ "buttons.createdraft" | translate }}
          </button>
          </div>
       </div>

    </div>
  </div>
</div>
